<template>
  <div class="empty-wrapper bg-neutral-50">
    <div>
      <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M52.1927 7.59985C62.5315 7.59985 68.3682 13.4639 68.3986 23.8027V52.1957C68.3986 62.5315 62.5315 68.3986 52.1927 68.3986H23.8027C13.4639 68.3986 7.59985 62.5315 7.59985 52.1957V23.8027C7.59985 13.4639 13.4639 7.59985 23.8027 7.59985H52.1927ZM39.5192 20.1548C38.665 19.638 37.6314 19.638 36.8137 20.1548C35.9898 20.6685 35.5369 21.614 35.625 22.5563V53.5333C35.7801 54.8405 36.8714 55.8133 38.1482 55.8133C39.4584 55.8133 40.5497 54.8405 40.6713 53.5333V22.5563C40.7929 21.614 40.34 20.6685 39.5192 20.1548ZM25.3227 30.1258C24.5019 29.609 23.4653 29.609 22.6475 30.1258C21.8237 30.6426 21.3708 31.5819 21.462 32.5273V53.5333C21.5805 54.8405 22.6749 55.8133 23.9821 55.8133C25.2923 55.8133 26.3836 54.8405 26.5052 53.5333V32.5273C26.5995 31.5819 26.1404 30.6426 25.3227 30.1258ZM53.4695 41.1608C52.6517 40.644 51.6182 40.644 50.767 41.1608C49.9431 41.6776 49.4902 42.5865 49.6118 43.5623V53.5333C49.7334 54.8405 50.8247 55.8133 52.1349 55.8133C53.4117 55.8133 54.5031 54.8405 54.6581 53.5333V43.5623C54.7462 42.5865 54.2933 41.6776 53.4695 41.1608Z" fill="#94A3B8"/>
      </svg>
      <div>
        Tidak ada data
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "empty-chart"
}
</script>

<style scoped>
  .empty-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 89px 0px 89.002px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
  }
</style>